export const REGION = 'region';
export const COUNTRY = 'country';
export const SECTOR = 'sector';
export const ORGANIZATION = 'organization';

export const getFilteredData = (attacks = [], filters = {}) => {
  const mappedFilters = [
    { key: ORGANIZATION, filter: filters.organization },
    { key: COUNTRY, filter: filters.country },
    { key: REGION, filter: filters.region },
    { key: SECTOR, filter: filters.sector }
  ];

  const searchFilter = filters.search.trim().toLowerCase();

  const tableData = attacks.filter(
    attack =>
      mappedFilters.every(({ key, filter }) => !filter.length || filter.includes(attack[key])) &&
      (!searchFilter.length ||
        mappedFilters.some(({ key }) => {
          const value = attack[key];
          if (Array.isArray(value)) return value.some(v => v?.toLowerCase().startsWith(searchFilter));
          return value?.toLowerCase().startsWith(searchFilter);
        }))
  );

  const { regions, countries, sectors } = tableData.reduce(
    (acc, curr) => {
      acc.regions[curr.region] = (acc.regions[curr.region] || 0) + 1;
      acc.countries[curr.country] = (acc.countries[curr.country] || 0) + 1;
      acc.sectors[curr.sector] = (acc.sectors[curr.sector] || 0) + 1;

      return acc;
    },
    { regions: {}, countries: {}, sectors: {} }
  );

  return {
    tableData,
    regions: Object.entries(regions),
    countries: Object.entries(countries),
    sectors: Object.entries(sectors)
  };
};
